import * as React from 'react';
import Svg, { Circle, Path } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

const SvgComponent = props => (
    <Svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
        <Circle cx={12.084} cy={14.167} r={2.5} stroke={props.color || ds.colorValue.icon.primary} strokeWidth={1.5} />
        <Circle cx={7.916} cy={5.833} r={2.5} stroke={props.color || ds.colorValue.icon.primary} strokeWidth={1.5} />
        <Path
            stroke={props.color || ds.colorValue.icon.primary}
            strokeWidth={1.5}
            d="M15 14.167h3.333M1.666 5.833h3.75M1.666 14.167h7.917M10 5.833h8.333"
        />
    </Svg>
);
export { SvgComponent as FilterIcon };
